import httpClient from "./http";

export const clinikoApi = {
  connect: (apiKey) => httpClient.post("/cliniko/connect", { apiKey }),
  getSyncStatus: () => httpClient.get("/cliniko/sync-status"),
  triggerSync: () => httpClient.post("/cliniko/sync"),
  getConnectionStatus: () => httpClient.get("/cliniko/connection-status"),
  getBusinesses: (params) => httpClient.get("/cliniko/businesses", { params }),
  getPractitioners: (params) => httpClient.get("/cliniko/practitioners", { params }),
  getAppointmentTypes: (params) => httpClient.get("/cliniko/appointment-types", { params }),
  getPatients: (params) => httpClient.get("/cliniko/patients", { params }),
  getAppointments: (params) => httpClient.get("/cliniko/appointments", { params }),
  saveGoogleBusiness: (data) => httpClient.post("/cliniko/google-business", data),
  getSetupProgress: () => httpClient.get("/cliniko/setup-progress"),
  completeOnboarding: () => httpClient.post("/cliniko/complete-onboarding"),
  autoSetup: (sendScope, logoFile) => {
    const formData = new FormData();
    formData.append("sendScope", sendScope);
    if (logoFile) formData.append("logo", logoFile);
    return httpClient.post("/cliniko/auto-setup", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
